import { render, staticRenderFns } from "./Feature10.vue?vue&type=template&id=57116eef&scoped=true"
import script from "./Feature10.vue?vue&type=script&lang=ts"
export * from "./Feature10.vue?vue&type=script&lang=ts"
import style0 from "./Feature10.vue?vue&type=style&index=0&id=57116eef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57116eef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
